module.exports = __webpack_public_path__ + "img/foclarity-logo-white-sm.94559ed0.png";